import { getLeadLayoutFields } from "../config/recordConfigs";
import { Button } from "../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";

export default function LeadImportTemplate() {
  const fields = getLeadLayoutFields();
  const download = () => {
    const esc = (s) => (/[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s);
    const lines = ["Field,Value", ...fields.map((f) => `${esc(f.label)},`)];
    const csv = lines.join("\n") + "\n";
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "arqitek-lead-import-template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="p-6 sm:p-8 space-y-6 max-w-3xl" data-testid="lead-import-template-page">
      <div>
        <span className="block text-xs uppercase tracking-[0.15em] text-primary mb-2">System · Data</span>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Lead Import Template</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">
          Download a CSV with every Lead field listed as a row — a <span className="font-medium text-foreground">Field</span> column
          and a blank <span className="font-medium text-foreground">Value</span> column. Fill in the values you have and upload it via
          {" "}<span className="font-medium text-foreground">Leads → Import Lead</span>. Fields are matched by name;
          unrecognized rows are ignored. One file creates one lead.
        </p>
      </div>
      <Button onClick={download} data-testid="download-template-btn">
        <Download className="h-4 w-4 mr-2" />Download CSV template
      </Button>
      <div className="rounded-lg border border-border bg-secondary/30 p-4">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
          <FileSpreadsheet className="h-3.5 w-3.5" />{fields.length} fields included
        </div>
        <div className="flex flex-wrap gap-1.5">
          {fields.map((f) => (
            <span key={f.key} className="text-[11px] rounded-full border border-border px-2 py-0.5 text-muted-foreground">{f.label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
